<div class='spinner-dialog-container'>

  <div class='spinner'>
    <img src='assets/images/geral/spinner.gif'>
  </div>

</div>
